<template>
  <section id="login" class="mt-5">
    <div class="container-fluid">
      <div class="row full-height-vh">
        <div class="col-12 d-flex align-items-center justify-content-center gradient-aqua-marine">
          <div class="card px-4 py-2 box-shadow-2 width-600">
            <div class="card-header text-center">
              <h1>{{ $t("labels.registration") }}</h1>
            </div>
            <div class="card-body">
              <div class="card-block">
                <form @submit.prevent="register" v-show="!showFeedback">
                  <div class="form-group">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control form-control-lg"
                        name="inputName"
                        id="inputName"
                        v-model="user.name"
                        :placeholder='$t("labels.name")'
                        required
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-md-12">
                      <input
                        type="text"
                        class="form-control form-control-lg"
                        name="inputSurname"
                        id="inputSurname"
                        v-model="user.surname"
                        :placeholder='$t("labels.surname")'
                        required
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-md-12">
                      <input
                        type="email"
                        class="form-control form-control-lg"
                        name="inputEmail"
                        id="inputEmail"
                        v-model="user.email"
                        :placeholder='$t("labels.email")'
                        required
                        email
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-md-12">
                      <input
                        type="password"
                        class="form-control form-control-lg"
                        name="inputPass"
                        id="inputPass"
                        v-model="user.password"
                        :placeholder='$t("labels.password")'
                        required
                      >
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-md-12">
                      <input
                        type="password"
                        class="form-control form-control-lg"
                        name="inputPassConfirm"
                        id="inputPassConfirm"
                        v-model="passwordConfirmation"
                        :placeholder='$t("labels.passwordConfirmation")'
                        required
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <div class="custom-control custom-checkbox clearfix">
                          <input type="checkbox" class="custom-control-input" id="privacy" v-model="user.privacy">
                          <label class="custom-control-label float-left ta-l" for="privacy" v-html="$t('labels.privacyLink')"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <div class="custom-control custom-checkbox clearfix">
                          <input type="checkbox" class="custom-control-input" id="tos" v-model="user.tos">
                          <label class="custom-control-label float-left ta-l" for="tos" v-html="$t('labels.tos')"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <div class="custom-control custom-checkbox clearfix">
                        <input type="checkbox" class="custom-control-input" id="privacyNotice" v-model="privacyNoticeRead">
                        <label class="custom-control-label float-left ta-l" for="privacyNotice" v-html="$t('labels.privacyNotice')"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <div class="custom-control custom-checkbox clearfix">
                          <input type="checkbox" class="custom-control-input" id="marketing" v-model="user.marketing">
                          <label class="custom-control-label float-left ta-l mb-3" for="marketing" v-html="$t('labels.marketingConsent')"></label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="text-center col-md-12">
                      <button
                        type="submit"
                        class="btn btn-danger px-4 py-2 text-uppercase white font-small-4 box-shadow-2 border-0"
                      >{{ $t("labels.submit") }}</button>
                    </div>
                  </div>
                </form>
                <ul class="links">
                  <li>
                    <router-link :to="{ name: 'login', query: {l: currentLocale }}">{{ $t("labels.haveAnAccount") }}</router-link>
                  </li>
                </ul>
                <div v-show="showFeedback">
                  <h4>{{ $t("labels.needToActivateFeedback") }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import AuthService from "../../services/auth";

export default {
  name: "RegisterPage",
  metaInfo: {
    title: "Dravet Diary registration", // set a title
    titleTemplate: "%s" // title is now "My Example App - Yay!",
  },
  props: {
    currentLocale: {
      type: String,
      default: 'it'
    }
  },
  data: function() {
    return {
      errors: [],
      showFeedback: false,
      message: '',
      user: {
        role: "user",
        privacy: false,
        tos: false,
        marketing: false
      },
      passwordConfirmation: '',
      privacyNoticeRead: false

    };
  },
  methods: {
    register: async function() {
      if (this.user.name == undefined || this.user.name.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.name')]))
      }

      if (this.user.surname == undefined || this.user.surname.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.surname')]))
      }

      if (this.user.email == undefined || this.user.email.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", ["E-mail"]))
      }

      if (!this.emailValidator(this.user.email)) {
          this.errors.push(this.$t("errors.invalidEmail"))
      }

      if (this.user.password == undefined || this.user.password.length == 0) {
          this.errors.push(this.$t("errors.cantBeEmpty", [this.$t('labels.password')]))
      }

      if (this.user.password != this.passwordConfirmation) {
          this.errors.push(this.$t("errors.passwordMatch"));
      }

      if (this.user.password.length < 8) {
          this.errors.push(this.$t("errors.passwordLength", ["8"]));
      }

      if (!this.user.privacy) {
          this.errors.push(this.$t("errors.mustBeChecked", [this.$t("labels.privacy")]));
      }

      if (!this.user.tos) {
          this.errors.push(this.$t("errors.mustBeChecked", [this.$t("labels.tos")]));
      }

      if (!this.privacyNoticeRead) {
          this.errors.push(this.$t("errors.mustBeChecked", [this.$t("labels.privacyNoticeShort")]));
      }
      
      if (this.errors.length == 0) {
        let result = await AuthService.register(this.user)
        if (result.data.success == true) {
          this.message = result.data.errors
          this.showFeedback = true 
          this.$miniToastr.success(this.$t("flash.createSuccess", [this.$t("models.account")]))
          this.user = {role: "user"}
          this.$router.push({ name: "login" });
        } else {
          for (let error in result.data.errors) {
            this.errors.push(result.data.errors[error].msg)
          }
          this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
        }
      } else {
        this.$miniToastr.error(this.errors.toString().split(",").join("<hr/>"))
        this.errors = []
      }
     
    },
    emailValidator(email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email)
    }
  }
};
</script>

<style scoped>
  .custom-control-label >>> a {
    position: relative;
    z-index: 2;
  }
</style>
